import React, { useState, useEffect } from 'react';
// const ReactDatePicker = require('react-datepicker')
import ReactDatePicker from 'react-datepicker';
import TextField from '../TextField/TextField';
import mergeStyles from '../../util/mergeStyles';
import { TouchableOpacity, View } from 'react-native';
import { Icon, } from '@ui-kitten/components';
import 'react-datepicker/dist/react-datepicker.css';
import colors from '../../../theming/themes/alucio/colors';
const DatePicker = (props) => {
    const { minDate, maxDate, onDismiss, placeholder, onDateSelected, onShowCalendar, selectedDate, showMonthYearDropDown = false, disabled = false, includeTimePicker = false, dateFormat, ...TextInputKittenProps } = props;
    const [currSelectedDate, setCurrSelectedDate] = useState(selectedDate);
    function handleChange(date) {
        setCurrSelectedDate(date);
        if (onDateSelected) {
            onDateSelected(date);
        }
    }
    useEffect(() => { setCurrSelectedDate(selectedDate); }, [selectedDate]);
    const Input = React.forwardRef(({ onChange, placeholder, value, onClick }, ref) => {
        const clickHandler = (e) => {
            onShowCalendar?.(e);
            onClick?.(e);
        };
        const calIcon = (props) => (<Icon {...props} name="calendar-month"/>);
        return (<TouchableOpacity onPress={clickHandler} activeOpacity={1}>
          <View pointerEvents="none">
            <TextField.Kitten size="large" textStyle={mergeStyles(undefined, {}, [{ color: '#000000' }, !disabled])} multiline={false} maxLength={10} disabled={true} style={{ backgroundColor: colors['color-text-basic'] }} placeholder={placeholder} value={value} accessoryRight={calIcon} onChange={onChange} 
        // @ts-ignore
        ref={ref} {...TextInputKittenProps}/>
          </View>
        </TouchableOpacity>);
    });
    return (<ReactDatePicker selected={currSelectedDate} onChange={handleChange} minDate={minDate} maxDate={maxDate} showYearDropdown={showMonthYearDropDown} showMonthDropdown={showMonthYearDropDown} showTimeInput={includeTimePicker} onCalendarClose={onDismiss} disabled={disabled} dateFormat={dateFormat} popperPlacement="top-start" portalId="root-portal" popperModifiers={{
        flip: {
            behavior: ['top', 'bottom'],
        },
        preventOverflow: {
            enabled: false,
        },
        hide: {
            enabled: false,
        },
    }} customInput={<Input />} timeIntervals={15}/>);
};
DatePicker.displayName = 'DatePicker';
export default DatePicker;
//# sourceMappingURL=DatePicker.web.js.map